import React from "react";
import classes from "./HeroBannerList.module.scss";
import { useMedia } from "../../hooks/useMedia";
import { connect } from "react-redux";
import { promotionclick, promotionview } from "../../providers/dataLayerAnalytics";

import dictionary from "i18next";

const HeroBannerList = ({ fields, isJumeirahGuest }) => {
  const isMobile = useMedia(["(max-width:992px)"], [true], false);

  React.useEffect(() => {
    if (window.location.pathname === "/") {
      window.location.pathname = `en`;
    }
  }, []);

  const bg_img_left =
    fields["Hero Banner List"][0].fields["Background Image"].value.src;
  const title_left = fields["Hero Banner List"][0].fields["Title"].value;
  const description_left =
    fields["Hero Banner List"][0].fields["Description"].value;
  const cta_text_left = fields["Hero Banner List"][0].fields["CTA Text"].value;
  const cta_link_left =
    fields["Hero Banner List"][0].fields["CTA link"].value.href;

  return (
    <div className={classes.heroBannerListWrap}>
      <div
        style={{
          backgroundImage: `url(
      ${bg_img_left}?h=600&w=615)`,
        }}
        className={classes.heroBannerLeft}
      >
        <div className={classes.linearGradient}></div>
        <div className={classes.heroBannerLeftContent}>
          <h1>{title_left}</h1>
          <div dangerouslySetInnerHTML={{ __html: description_left }}></div>
          <a href={cta_link_left} onClick={() => promotionclick(fields["Hero Banner List"][0],true)}>{cta_text_left} </a>
        </div>
      </div>
      <div className={classes.heroBannerRight}>
        {fields["Hero Banner List"].map((eachCard, index) => {
          if (index > 0) {
            return !isMobile ? (
              <div className={classes.subCards}>
                <div
                  className={classes.subImage}
                  style={{
                    backgroundImage: `url(
            ${eachCard.fields["Background Image"].value.src}?h=297&w=337)`,
                  }}
                ></div>
                <div className={classes.linearGradient}></div>

                <div className={classes.subCardContent}>
                  <div>
                    <h2>{eachCard.fields["Title"].value}</h2>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          isJumeirahGuest && index === 1
                            ? dictionary.t(
                                "Home-JumeirahGuestSpecialOffer",
                                "Jumeirah special guest rate starting from 149 AED"
                              )
                            : eachCard.fields["Description"].value,
                      }}
                    ></div>
                  </div>
                  <div>
                    <a href={eachCard.fields["CTA link"].value.href} onClick={() => promotionclick(eachCard,true)}>
                      {" "}
                      {eachCard.fields["CTA Text"].value}
                    </a>
                  </div>
                </div>
              </div>
            ) : (
              <div
                onClick={() => {
                            promotionclick(eachCard, true);
                            window.location.href = eachCard.fields["CTA link"].value.href;

                }}
                className={classes.subCardsMobile}
              >
                <div className={classes.subCardsMobileHero}>
                  <div
                    className={classes.subImage}
                    style={{
                      backgroundImage: `url(
                           ${eachCard.fields["Background Image"].value.src}?h=297&w=337)`,
                    }}
                  ></div>
                  <div className={classes.linearGradient}></div>
                  <div className={classes.subCardContent}>
                    <div>
                      <h2>{eachCard.fields["Title"].value}</h2>
                    </div>
                  </div>
                </div>

                <div
                  style={{ height: "20%", padding: "5px" }}
                  dangerouslySetInnerHTML={{
                    __html: eachCard.fields["Description"].value,
                  }}
                ></div>
              </div>
            );
          }
        })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    isJumeirahGuest: state.bookingDetailsV2.isJumeirahGuest,
  };
};

export default connect(mapStateToProps, null)(HeroBannerList);
